import proxy from './axios';
import { getToken } from '../common/utils';

/**
 * New execution engine — function mode + function-mode contests.
 * Legacy io problems continue using /code/* routes.
 *
 * Contest judgingMode wins when set (LiveContest passes 'io' | 'function').
 * Practice: pass null/undefined so routing follows problem.mode.
 */
export const executionRun = async ({ sourceCode, language, languageId, slug, testCase, contestId }) => {
  const { data } = await proxy.post('/execution/run', {
    source_code: sourceCode,
    language,
    language_id: languageId,
    slug,
    testCase,
    contestId: contestId || null,
  });
  return data;
};

export const executionSubmit = async ({
  sourceCode,
  language,
  languageId,
  slug,
  contestId,
  challenge,
}) => {
  const { data } = await proxy.post(
    '/execution/submit',
    {
      source_code: sourceCode,
      language,
      language_id: languageId,
      slug,
      contestId: contestId || null,
      challenge: challenge || null,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    },
  );
  return data;
};

export const shouldUseExecutionEngine = (problem, contestJudgingMode) => {
  if (contestJudgingMode === 'function') return true;
  if (contestJudgingMode === 'io') return false;
  return problem?.mode === 'function';
};
